import { api } from "@shared/api/client";
import type {
  RequisitoLegalControlModificacion,
  RequisitoLegalControlModificacionPayload,
  RequisitoLegalPayload,
  RequisitoLegalRow,
  RequisitosLegalesResponse,
} from "../types/requisitos-legales";

export async function getCalidadRequisitosLegales() {
  const { data } = await api.get<RequisitosLegalesResponse>(
    "/certificaciones/iso-9001-14001/requisitos-legales",
  );

  return data;
}

export async function createCalidadRequisitoLegal(payload: RequisitoLegalPayload) {
  const { data } = await api.post<{ ok: boolean; data: RequisitoLegalRow }>(
    "/certificaciones/iso-9001-14001/requisitos-legales",
    payload,
  );

  return data.data;
}

export async function updateCalidadRequisitoLegal(
  requisitoId: number,
  payload: RequisitoLegalPayload,
) {
  const { data } = await api.put<{ ok: boolean; data: RequisitoLegalRow }>(
    `/certificaciones/iso-9001-14001/requisitos-legales/${requisitoId}`,
    payload,
  );

  return data.data;
}

export async function deleteCalidadRequisitoLegal(requisitoId: number) {
  await api.delete(`/certificaciones/iso-9001-14001/requisitos-legales/${requisitoId}`);
}

export async function createCalidadRequisitoLegalControlModificacion(
  payload: RequisitoLegalControlModificacionPayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: RequisitoLegalControlModificacion;
  }>("/certificaciones/iso-9001-14001/requisitos-legales/control-modificaciones", payload);

  return data.data;
}

export async function updateCalidadRequisitoLegalControlModificacion(
  id: number,
  payload: RequisitoLegalControlModificacionPayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: RequisitoLegalControlModificacion;
  }>(`/certificaciones/iso-9001-14001/requisitos-legales/control-modificaciones/${id}`, payload);

  return data.data;
}

export async function deleteCalidadRequisitoLegalControlModificacion(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/requisitos-legales/control-modificaciones/${id}`);
}
